import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import { obtenerArchivos } from "../AccionesBackend";
import { VisualizadorPdfs } from "./VisualizadorPdfs";
import { BotonRegresar } from "../BotonRegresar";

const Nom035 = () => {
    const [flyers, setFlyers] = useState([]);
    const [error, setError] = useState(null);
    const seccionId = 6;

    useEffect(() => {
        const fetchFlyers = async () => {
            try {
                const response = await obtenerArchivos({ seccionId: seccionId });
                if (response && response.success) {
                    if (response.archivos && response.archivos.length > 0) {
                        const mappedFlyers = response.archivos.map(file => ({
                            src: file.ruta_archivo,
                            title: file.nombre_archivo,
                        }));
                        setFlyers(mappedFlyers);
                    } else {
                        setError("No se encontraron archivos.");
                    }
                } else {
                    setError("Error al obtener los archivos.");
                    console.error("No se pudieron obtener los archivos");
                }
            } catch (err) {
                setError("Error en la conexión o en el servidor.");
                console.error("Error al obtener los archivos:", err);
            }
        };

        fetchFlyers();
    }, []);

    return (
        <section className="nom035">
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1>NOM 035</h1>
                </div>
                { error ? (
                    <p style={{ textAlign: "center", padding: "20px", color: "red" }}>{error}</p>
                ) : (
                    <VisualizadorPdfs initialPdfs={flyers} />
                )}
            </Container>
        </section>
    );
};

export default Nom035;

